import { useEffect, useRef } from "react";

const useOkendo = () => {
	const widgetContainer = useRef(null);

	const initialiseWidget = () =>
		window.okeWidgetApi.initWidget(widgetContainer.current);

	useEffect(() => {
		if (window.okeWidgetApi?.initWidget) {
			initialiseWidget();
		} else {
			document.addEventListener("oke-script-loaded", initialiseWidget);
		}

		return () => {
			document.removeEventListener("oke-script-loaded", initialiseWidget);
		};
	}, []);

	return widgetContainer;
};

export default useOkendo;